import { PrimeWorkspace } from 'iam/WorkspaceStore'
import { collection } from 'infra/collection'
import { MessageBankAPI } from '../API'
import { MessageBankDTO } from '../dtos/message-bank'
import { MessageBank } from './MessageBank'

export class MessageBankStore {
  messageBanks = collection<MessageBankDTO, MessageBank>({
    create: () => new MessageBank(this.primeWorkspace),
  })

  constructor(
    private api: MessageBankAPI,
    private primeWorkspace: PrimeWorkspace,
  ) {}

  getForWorkspace(workspaceId: string) {
    return (
      this.messageBanks.find((mb) => mb.workspace.id === workspaceId) ?? null
    )
  }

  /**
   * Returns the workspace's message bank.
   *
   * @param workspaceId
   * @returns
   */
  async fetchWorkspaceMessageBank(workspaceId: string) {
    return this.api.findForWorkspace(workspaceId).then(this.messageBanks.set)
  }

  async fetchMessageBankReplies(messageBankId: string) {
    const messageBank = this.messageBanks.get(messageBankId)
    const replies = await this.api
      .getReplies(messageBankId)
      .then((data) => data.data)

    if (messageBank && replies) {
      return messageBank.replies.set(replies)
    }

    return []
  }
}
